$drag_handle_width: 30px;

.fl_drag_handle {
	width: $drag_handle_width;
	min-width: $drag_handle_width;
}

.fl_list_item {

	&[data-draggable="true"] {
		width: calc(100% - $drag_handle_width);
	}
}

$item_preview_width_xs: 40px;
$item_preview_height_xs: 40px;

$item_preview_width_sm: 50px;
$item_preview_height_sm: 50px;

$item_preview_width_md: 100px;
$item_preview_height_md: 56px;

$item_preview_width_lg: 130px;
$item_preview_height_lg: 73px;

$item_preview_width_xl: 150px;
$item_preview_height_xl: 84px;

.fl_list_item__preview {
	overflow: hidden;
	min-height: 40px;
}

.fl_list_item__action {
	font-size: 14px;
}

.fl_list_item[data-size="xs"] {

	.fl_list_item__name {
		font-size: 12px;
	}

	.fl_list_item__preview {
		width: $item_preview_width_xs;
		max-width: $item_preview_width_xs;
		height: $item_preview_height_xs;
		max-height: $item_preview_height_xs;
	}

	.fl_list_item__action {
		font-size: 12px !important;
	}

}

.fl_list_item[data-size="sm"] {

	.fl_list_item__name {
		font-size: 13px;
	}

	.fl_list_item__preview {
		width: $item_preview_width_sm;
		max-width: $item_preview_width_sm;
		height: $item_preview_height_sm;
		max-height: $item_preview_height_sm;
	}

	.fl_list_item__action {
		font-size: 13px !important;
	}
}

.fl_list_item[data-size="md"] {

	.fl_list_item__name {
		font-size: 14px;
	}

	.fl_list_item__preview {
		width: $item_preview_width_md;
		max-width: $item_preview_width_md;
		height: $item_preview_height_md;
		max-height: $item_preview_height_md;
	}

	.fl_list_item__action {
		font-size: 14px !important;
	}
}

.fl_list_item[data-size="lg"] {

	.fl_list_item__name {
		font-size: 15px;
	}

	.fl_list_item__preview {
		width: $item_preview_width_lg;
		max-width: $item_preview_width_lg;
		height: $item_preview_height_lg;
		max-height: $item_preview_height_lg;
	}

	.fl_list_item__action {
		font-size: 15px !important;
	}
}

.fl_list_item[data-size="xl"] {

	.fl_list_item__name {
		font-size: 16px;
	}

	.fl_list_item__preview {
		width: $item_preview_width_xl;
		max-width: $item_preview_width_xl;
		height: $item_preview_height_xl;
		max-height: $item_preview_height_xl;
	}

	.fl_list_item__action {
		font-size: 16px !important;
	}
}